import AppConstants from '../constants/AppConstants';
import { getTotalPages } from './helper';

export const initialState = {
    list: [],
    page: 1,
    total: 1,
    loading: false
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {

        case AppConstants.POSTBACK_HISTORY_START_LOADING:
            return {
                ...state,
                loading: true
            };

        case AppConstants.POSTBACK_HISTORY_SUCCESS:
            return {
                list: action.items.items,
                page: action.items.page,
                total: getTotalPages(action.items.total, action.items.count),
                loading: false
            };

        case AppConstants.POSTBACK_HISTORY_FAIL:
            return {
                ...state,
                loading: false
            };

        default:
            return state;
    }
};
